import styled from "styled-components";
export const LotteryContainer = styled.div`
  padding: 128px 0;
  .caption {
    line-height: 36px;
    padding-left: 36px;
  }
  .query {
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
    padding: 16px;
    .form-item {
      margin-bottom: 24px;
    }
    button {
      width: 100%;
    }
  }
`;
